import React from 'react';
import type { BrandTeamAgentLog } from '../../../../services/brandTeamService';
import { getAgentPersona } from '../constants';

interface ActivityFeedProps {
  logs: BrandTeamAgentLog[];
}

function timeAgo(dateStr: string): string {
  const seconds = Math.floor((Date.now() - new Date(dateStr).getTime()) / 1000);
  if (seconds < 10) return 'Just now';
  if (seconds < 60) return `${seconds}s ago`;
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  return `${Math.floor(minutes / 60)}h ago`;
}

const ActivityFeed: React.FC<ActivityFeedProps> = ({ logs }) => {
  const sorted = [...logs].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

  return (
    <div className="border-t border-primary-100 px-3 py-3">
      <h4 className="mb-2 text-[10px] font-semibold uppercase tracking-wider text-body-grey">Live Activity</h4>
      <div className="space-y-1.5 max-h-40 overflow-y-auto">
        {sorted.slice(0, 10).map((log) => {
          const persona = getAgentPersona(log.agentKey);
          return (
            <div key={log.id} className="flex items-start gap-2 text-[11px]">
              <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-brand-purple" />
              <div className="min-w-0 flex-1">
                <span className="font-semibold text-brand-purple">{persona.name}</span>{' '}
                <span className="text-body-grey">{log.summary}</span>
                <div className="text-[9px] text-gray-400">{timeAgo(log.createdAt)}</div>
              </div>
            </div>
          );
        })}
        {logs.length === 0 && <p className="text-[11px] text-gray-400 italic">No activity yet</p>}
      </div>
    </div>
  );
};

export default ActivityFeed;
